var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{attrs:{"color":"primary","label":"Export"},on:{"click":_vm.exportXlsx}})
}
var staticRenderFns = []

export { render, staticRenderFns }